import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { ItemDetail } from '../../../types/item-detail';
import { GroupByStockPipe } from '../../../pipes/group-by-stock.pipe';

import { IconComponent } from '@softline/ui-core';
import { SortPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-details',
  imports: [CdkAccordionModule, CommonModule, GroupByStockPipe,
    IconComponent,
    SortPipe,
    TranslatePipe],
  templateUrl: './details.html',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class Details {
  data = input.required<ItemDetail | null>();
  hideLagerplaetze = input.required<boolean>();
  hideEinheiten = input.required<boolean>();
  hideLieferanten = input.required<boolean>();

  lagerplaetzeExpanded = input.required<boolean>();
  einheitenExpanded = input.required<boolean>();
  lieferantenExpanded = input.required<boolean>();
}
